<template>
    <Header :building="building">
        <template v-slot:orbital-nav>
            <div v-if="project && building" class="header--orbital" :key="'orbital-'+key">
                <div class="row--content">
                    <div class="resp--header">
                        <div class="filters">
                            <button v-if="withFilter" class="btn--open_filters btn--filter_resp" @click.prevent="handleOpenFilters">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                     fill="#000000">
                                    <path d="M0 0h24v24H0z" fill="none"/>
                                    <path
                                        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                                </svg>
                            </button>
                            <svg @click.prevent.stop="handleOpenControls" class="cursor-pointer"
                                 xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                                 fill="#000000">
                                <path d="M0 0h24v24H0V0z" fill="none"/>
                                <path
                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                            </svg>
                        </div>
                    </div>
                    <div v-if="project && building" class="index--floors">
                        <router-link
                            :to="{ name: 'orbital-show', params: { project: assetSlug(project.name), building: assetSlug(building.name), locale: locale } }"
                            v-if="building && floors.length > 1"
                            class="floor">
                            {{ t('BAT', 'BAT') }}
                        </router-link>

                        <router-link
                            v-if="floors.length > 1"
                            v-for="floor in floors"
                            :to="{ name: 'orbital-show', params: { project: assetSlug(project.name), building: assetSlug(building.name), floor: assetSlug(floor.name), locale: locale } }"
                            class="floor"
                            :class="namesMatch(floor.name, $route.params.floor) ? 'router-link-exact-active' : ''"
                            @click="handleResetCurrentUnit">
                            {{ floor.translatable.description[locale] || floor.description }}
                        </router-link>
                    </div>
                </div>
                <div class="back-btn_wrapper">
                    <router-link :to="{ name: 'orbital-show', query: {}, params: { locale: locale } }" v-if="building && building.building_id !== null" class="back--to_btn cursor-pointer back-to_desk">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><rect fill="none" height="24" width="24"/><path d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z"/></svg>
                        <span class="back--to">{{ t('Retour à la maquette principale', 'Retour à la maquette principale') }}</span>
                    </router-link>
                </div>
            </div>
        </template>
    </Header>

    <section class="main" data-barba="container" data-barba-namespace="home">
        <section class="orbital" data-barba="container" data-barba-namespace="orbital">
            <div class="content--orbital">
                <Controls
                    :has-been-seen="hasBeenSeen"
                    @closeControls="handleCloseControls"
                />
                <Orbital
                    v-if="name"
                    :frames-path="currentFramesPath"
                    :frames-extension="extension"
                    :current-polygons-path="currentPolygonsPath"
                    :units="units"
                    :project="project"
                    :current-unit="currentUnit"
                    :name="name"
                    :results="results"
                    :floor="floor"
                    :building="building"
                    :categories="categories"
                    :withFilter="withFilter"
                    :isImagesPending="isImagesPending"
                    :selectedUnit="selectedUnit"
                    :showLoader="showLoader"
                    @setCurrentUnit="handleSetCurrentUnit"
                    @showUnit="handleShowUnit"
                    @selectBuilding="handleSelectBuilding"
                    @setIsPending="handleSetIsImagesPending"
                />
            </div>
            <div class="navigation--wrapper">
                <div class="filters filters--hide_resp">
                    <div
                        class="flex items-center flex-col gap-2"
                        v-if="building && (withFilter || isOrbitalModalEnabled)"
                    >
                        <button
                            v-if="withFilter && !isParentBuilding"
                            class="btn--open_filters btn--main w-full"
                            @click.prevent="handleOpenFilters"
                        >
                            {{ t('Filtre', 'Filtre') }}
                        </button>
                        <button
                            v-if="isOrbitalModalEnabled"
                            class="btn--open_info btn--main w-full"
                            @click.prevent="handleOpenInfoModal"
                        >
                            {{ t('Informations', 'Informations') }}
                        </button>
                    </div>
                    <div class="controls--alignement">
                        <svg @click.prevent.stop="handleOpenControls" class="cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                             height="30px" viewBox="0 0 30 30" width="30px" fill="#000000">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                        </svg>
                    </div>
                    <!--Name of the building-->
                    <span v-if="building && building.building_id !== null" class="text-4xl ml-12">{{ building ? building.description : ''}}</span>
                </div>
                <div class="bottom--content">
                    <div v-if="project && project.show_category && categories.filter( category => floorCategories.includes(category.id) ).length > 0" class="legend">
                        <span v-for="category in categories.filter( category => floorCategories.includes(category.id) )" :key="'category-'+category.id" class="nbres--bed">
                            {{ category.name }}
                            <span class="dot" :style="{backgroundColor: category.color}"></span>
                        </span>
                    </div>

                    <div v-else-if="maxTopology >= 1 && maxTopology <= 10 && floorTopologies.length > 0" class="legend">
                        <template v-for="topology in floorTopologies">
                            <span class="nbres--bed">
                                <template v-if="PROJECT_TOPOLOGY.labels[project.topology] === 'T'">
                                    {{ topology === 0 ? t('ST', 'ST') : t('T', 'T') + topology }}
                                </template>
                                <template v-else>
                                    {{ topology === 0 ? t('studio', 'studio') : topology + ' ' + t('ch.', 'ch.') }}
                                </template>
                                <span v-if="project.settings.data.find( setting => setting.name === 't'+topology+'-color')" class="dot" :style="{backgroundColor: project.settings.data.find( setting => setting.name === 't'+topology+'-color').value}"></span>
                            </span>
                        </template>
                    </div>
                </div>
            </div>
            <Filters
                @closeFilters="handleCloseFilters"
                @openFilters="handleOpenFilters"
                @closeUnit="handleCloseUnit"
                @setCurrentUnit="handleSetCurrentUnit"
                @showUnit="handleShowUnit"
                @search="handleSearch"
                @toggleResults="handleToggleResults"
                @setSelectedUnit="handleSelectedUnit"
                @resetResults="handleResetResults"
                :is-filters-open="isFiltersOpen"
                :is-results-open="isResultsOpen"
                :is-unit-open="isUnitOpen"
                :is-section-open="isSectionOpen"
                :floors="this.building ? this.building.floors.data : []"
                :current-unit="currentUnit"
                :project="this.project"
                :building="this.building"
                :floor="this.floor"
                :results="results"
                :categories="categories"
                :withFilter="withFilter"
            />
        </section>
    </section>
    <OrbitalModal v-if="project" :project="project" :building="building" ref="orbitalModalRef" />
</template>

<script>
    import Header from "../components/Header";
    import Axios from "axios";

    import PROJECT_TOPOLOGY from "../enums/project-topology";

    import Orbital from "../components/orbital/Orbital";
    import Controls from "../components/orbital/Controls";
    import Filters from "../components/orbital/Filters";
    import CircularLoader from "../components/orbital/Circular-Loader";
    import Loader from "../components/partials/loader";
    import OrbitalModal from "../components/orbital/OrbitalModal";
    import t from "../composables/Translator";
    import { assetPath, assetSlug, namesMatch } from "../composables/assetSlug";

    export default {
        beforeRouteUpdate(to, from, next) {
            this.key++;
            this.name = null;

            this.getDataFromParams(to.params);
            this.getCategories();

            next()
        },
        beforeMount() {
            window.addEventListener('resize', this.onResize);

            this.getDataFromParams(this.$route.params);

            this.getCategories();
        },
        data() {
            return {
                key: 0,
                isMenuOpen: false,
                currentFramesPath: null,
                currentPolygonsPath: null,
                selectedFloor: null,
                extension: this.canUseWebp() ? 'webp' : 'jpg',
                orbitalsPath: null,
                floor: null,
                project: null,
                name: null,
                building: null,
                currentUnit: null,
                hasBeenSeen: true,
                PROJECT_TOPOLOGY: PROJECT_TOPOLOGY,
                results: [],
                isFiltersOpen: false,
                isUnitOpen: false,
                isResultsOpen: false,
                isSectionOpen: false,
                isPending: true,
                isImagesPending: true,
                categories: [],
                selectedUnit: null,
                showLoader: true
            }
        },
        watch: {
            name : {
                handler(name) {
                    let orbitalsPath = process.env.MIX_APP_URL + '/storage/orbitals';
                    this.currentFramesPath = orbitalsPath + '/' + assetPath(this.project?.name, this.building?.name, name);
                    this.currentPolygonsPath = assetPath(this.project?.name, this.building?.name);
                    this.selectedFloor = name;
                    this.orbitalsPath = orbitalsPath;
                },
                deep: true
            },
            isPending() {
                this.key++
            },
        },
        computed: {
            isFrontOfficePending() {
                return this.$store.state.frontoffice.isPending;
            },
            domain() {
                return this.$store.state.frontoffice.domain;
            },
            floors() {
                return this.building ? this.building.floors.data : []
            },
            units() {
                return this.floor ? this.floor.units.data : []
            },
            locale() {
                return this.$store.getters['config/locale'];
            },
            maxTopology() {
                let bedrooms = this.units.map( unit => unit.bedrooms );

                return Math.max(...bedrooms);
            },
            floorTopologies() {
                if(this.floor && this.floor.units && this.floor.units.data) {
                    return this.floor.units.data
                                .filter( unit => Number(unit?.status_id) !== 2)
                                .map( unit => unit.bedrooms )
                                .reduce(
                                    (unique, item) => (unique.includes(item) ? unique : [...unique, item]),
                                    [],
                                ).sort();
                }

                return [];
            },
            floorCategories() {
                if(this.floor && this.floor.units && this.floor.units.data) {
                    return this.floor.units.data.map( unit => unit.category_id );
                }

                return [];
            },
            withFilter() {
                if(this.domain && this.domain.settings.data.find( setting => setting.name === 'with-filter' )) {
                    return !!Number(this.domain.settings.data.find( setting => setting.name === 'with-filter' ).value)
                }

                return false
            },
            // A parent building shows its child buildings, not units, so it has nothing to filter.
            // The only building of a single-building project is a root too, and keeps the filter.
            isParentBuilding() {
                return !!(this.building && this.building.building_id === null && this.building.buildings && this.building.buildings.data.length > 0);
            },
            isOrbitalModalEnabled() {
                // Priorité au paramétrage bâtiment, puis fallback projet
                if (this.building && this.building.settings && this.building.settings.data) {
                    const buildingSetting = this.building.settings.data.find(
                        setting => setting.name === 'orbital-modal-enabled'
                    );

                    if (buildingSetting) {
                        return !!Number(buildingSetting.value);
                    }
                }

                if (this.project && this.project.settings && this.project.settings.data) {
                    const projectSetting = this.project.settings.data.find(
                        setting => setting.name === 'orbital-modal-enabled'
                    );
                    return projectSetting ? !!Number(projectSetting.value) : false;
                }

                return false;
            }
        },
        methods: {
            assetSlug,
            namesMatch,
            handleOpenFilters() {
                this.isFiltersOpen = true;
            },
            handleCloseFilters() {
                this.isFiltersOpen = false;
                this.isResultsOpen = false;
                this.isUnitOpen = false;
                this.isSectionOpen = false;
            },
            handleSetCurrentUnit({unit, refresh = true}) {
                this.currentUnit = unit;
                this.isUnitOpen = false;
                this.isSectionOpen = false;
                this.isResultsOpen = false;

                if (unit && refresh) {
                    this.$router.push({
                        name: 'orbital-show', params: {
                            project: assetSlug(this.project.name),
                            building: assetSlug(this.building.name),
                            floor: assetSlug(this.floors.filter(floor => Number(floor.id) === Number(unit.floor_id))[0] ? this.floors.filter(floor => Number(floor.id) === Number(unit.floor_id))[0].name : this.floors[0].name),
                            unit: unit.name
                        }, query: this.$route.query
                    })
                }
            },
            handleToggleResults() {
                this.isResultsOpen = !this.isResultsOpen;
                this.isSectionOpen = !this.isSectionOpen;
                if (this.isSectionOpen && this.isResultsOpen) {
                    this.isFiltersOpen = true
                }
            },
            handleCloseUnit() {
                this.currentUnit = null
            },
            handleCloseControls() {
                this.hasBeenSeen = true;
            },
            handleOpenControls() {
                this.hasBeenSeen = false;
            },
            canUseWebp() {
                let elem = document.createElement('canvas');
                if (!!(elem.getContext && elem.getContext('2d'))) {
                    // was able or not to get WebP representation
                    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
                }
                // very old browser like IE 8, canvas not supported
                return false;
            },
            handleSearch({bedrooms, surface, price, isUnavailable, options, categories, isDuplex}) {
                this.isResultsOpen = true;
                this.isSectionOpen = true;
                this.isUnitOpen = false;

                if (bedrooms && surface && price && options) {
                    this.results = this.floors.map(floor => {
                        if (bedrooms.length === 0 && price === 0 && surface === 0 && options.length === 0 && !isDuplex) {
                            return {
                                ...floor,
                                units: floor.units.data
                            };
                        } else {
                            return {
                                ...floor,
                                units: floor.units.data.filter(unit => {
                                        return (bedrooms.length > 0 && !this.project.show_category ? bedrooms.includes(unit.bedrooms) : true) &&
                                            (this.project.show_category ? categories.includes(Number(unit.category_id)) : true) &&
                                            Number(unit.surface) >= Number(surface[0]) &&
                                            Number(unit.surface) <= Number(surface[1]) &&
                                            (this.project.show_price ? (
                                                Number(unit.price) >= Number(price[0]) &&
                                                Number(unit.price) <= Number(price[1])
                                            ) : true) &&
                                            (isUnavailable ? true : Number(unit?.status_id) === 1) &&
                                            (
                                                options.length === 0 ?
                                                    true
                                                    :
                                                    (Array.from([
                                                        options.includes('has_terrace') ? unit.has_terrace : null,
                                                        options.includes('has_balcony') ? unit.has_balcony : null,
                                                        options.includes('has_garden') ? unit.has_garden : null,
                                                        options.includes('has_loggia') ? unit.has_loggia : null,
                                                    ]).filter(n => n !== null).includes(true))
                                            ) &&
                                            (isDuplex ? unit.unit_id !== null : unit.unit_id === null)
                                    }
                                )
                            }
                        }
                    })
                }
            },
            // Les catégories pilotent la légende, les filtres et, en show_category, la couleur
            // des zones : l'endpoint n'étant cloisonné ni par domaine ni par projet, il faut le
            // filtrer sur le projet courant, sinon la première page renvoie les typologies
            // d'autres projets et celles du projet courant en sortent dès qu'elles sont nombreuses.
            getCategories() {
                if(!this.project) {
                    this.categories = [];
                    this.isPending = false;

                    return;
                }

                Axios.get(`${process.env.MIX_APP_URL}/categories?filter[project_id]=${this.project.id}&per_page=100`).then(response => {
                    this.categories = response.data.data
                    this.isPending = false;
                })
            },
            getDataFromParams(params) {
                this.isPending = true;
                let subdomain = window.location.host;

                if(params.project) {
                    this.project = this.domain?.projects.data.find( project => namesMatch(project.name, params.project) );
                }else {
                    if(process.env.NODE_ENV === 'development' && process.env.MIX_DEFAULT_DOMAIN) {
                        this.project = this.domain?.projects.data.find( project => Number(project.domain.id) === Number(process.env.MIX_DEFAULT_DOMAIN) );
                    }else if(this.domain.projects.data.find( project => project.domain.host.toLowerCase() === subdomain.toLowerCase() ) !== undefined){
                        this.project = this.domain?.projects.data.find( project => project.domain.host.toLowerCase() === subdomain.toLowerCase() );
                    }else {
                        this.project = this.domain?.projects.data[0];
                    }
                }

                if(!this.project) {
                    console.error('no project', this.domain);
                    this.$store.dispatch('toasts/add', {type: 'error', message: 'Aucun projet chargé'})
                    return false;
                }

                // return to 404 if no project ?
                if (params && params.building) {
                    this.building = this.project.buildings.data.find(building => namesMatch(building.name, params.building));
                }else {
                    if(this.project.buildings.data.length > 1) {
                        this.building = this.project.buildings.data.find(building => building.building_id === null);
                    }else {
                        this.building = this.project.buildings.data[0]
                    }
                }

                this.floor = null;

                if (params && params.floor) {
                    this.floor = this.building.floors.data.find( floor => namesMatch(floor.name, params.floor) && Number(floor.building_id) === Number(this.building.id) );
                    this.name = this.floor.name;

                    if (params.unit) {
                        this.handleSetCurrentUnit({unit: this.units.find(unit => unit.name === params.unit), refresh: false})
                        if(this.$route.query.showUnit === 'true') {
                            this.handleShowUnit(this.units.find(unit => unit.name === params.unit))
                        }
                    }
                }else {
                    this.name = this.floor ? this.floor.name : 'full';
                }

                this.isPending = false;
            },
            handleShowUnit(unit) {
                this.currentUnit = unit;
                if(window.innerWidth <= 1100) {
                    this.isFiltersOpen = false;
                }else {
                    this.isFiltersOpen = true;
                }
                this.isSectionOpen = true;
                this.isUnitOpen = true;
                this.isResultsOpen = false;
            },
            handleResetCurrentUnit() {
                this.currentUnit = null;
            },
            handleOpenModal(modalName) {
                this.$store.dispatch('modals/open', modalName)
            },
            handleSelectBuilding(building_name) {
                this.$router.push({ name: 'orbital-show', params: { project: assetSlug(this.project.name), building: assetSlug(building_name) } })
            },
            handleSetIsImagesPending(isPending){
                this.isImagesPending = isPending;
                this.showLoader = isPending;
            },
            handleSelectedUnit(unit) {
                this.selectedUnit = unit;
            },
            handleResetResults() {
                this.results = this.floors.map(floor => {
                        return {
                            ...floor,
                            units: floor.units.data
                        }
                })
            },
            t(...args) {
                return t(...args);
            },
            handleOpenInfoModal() {
                if(this.$refs.orbitalModalRef) {
                    this.$refs.orbitalModalRef.openModal();
                }
            }
        },
        components: {
            Header,
            Orbital,
            Controls,
            Filters,
            CircularLoader,
            Loader,
            OrbitalModal,
        }
    }
</script>
